window.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("#btnToScrollForm").forEach(button => {
        if (!button) return;

        button.addEventListener("click", scrollToForm)
    })
})

function scrollToForm() {
    if (!this.dataset.version) {
        const closeMobileMenuButton = document.querySelector("#closeMobileMenu");
        closeMobileMenuButton.click()
    }

    const header = document.querySelector("header")
    const form = document.querySelector("#form")
    if (!form) return

    const coordY = form.offsetTop - header.offsetHeight

    scrollTo({
        behavior: "smooth",
        top: coordY,
    })
}
